var map = {
	"./NodeChunkTemplatePlugin": 489,
	"./NodeChunkTemplatePlugin.js": 489,
	"./NodeEnvironmentPlugin": 816,
	"./NodeEnvironmentPlugin.js": 816,
	"./NodeHotUpdateChunkTemplatePlugin": 490,
	"./NodeHotUpdateChunkTemplatePlugin.js": 490,
	"./NodeMainTemplate.runtime": 491,
	"./NodeMainTemplate.runtime.js": 491,
	"./NodeMainTemplateAsync.runtime": 492,
	"./NodeMainTemplateAsync.runtime.js": 492,
	"./NodeMainTemplatePlugin": 493,
	"./NodeMainTemplatePlugin.js": 493,
	"./NodeOutputFileSystem": 494,
	"./NodeOutputFileSystem.js": 494,
	"./NodeSourcePlugin": 340,
	"./NodeSourcePlugin.js": 340,
	"./NodeTargetPlugin": 229,
	"./NodeTargetPlugin.js": 229,
	"./NodeTemplatePlugin": 341,
	"./NodeTemplatePlugin.js": 341,
	"./NodeWatchFileSystem": 495,
	"./NodeWatchFileSystem.js": 495,
	"./OldNodeWatchFileSystem": 817,
	"./OldNodeWatchFileSystem.js": 817
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 815;



//////////////////
// WEBPACK FOOTER
// (webpack)/lib/node ^\.\/.*$
// module id = 815
// module chunks = 0